import { render } from "./Vizsgazoknak.vue?vue&type=template&id=f33ff4f2&scoped=true"
import script from "./Vizsgazoknak.vue?vue&type=script&lang=js"
export * from "./Vizsgazoknak.vue?vue&type=script&lang=js"

import "./Vizsgazoknak.vue?vue&type=style&index=0&id=f33ff4f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\source\\MFVK\\menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f33ff4f2"]])

export default __exports__